import React, { ReactElement, useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Body2 } from './../../../../components/UI/MDC/Typography/Typography';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';

/**
 * Wrapping component for App Processing Form
 *
 * @returns {ReactElement} rendered component.
 */

const RequestInformation = ({ requestInfo, assignInfo, requestor }) => {
	const [openTooltip, setOpenTooltip] = useState(false);

	const [request, setRequest] = useState({
		'ESO ID': undefined,
		Address: undefined,
		Email: undefined,
		UPN: undefined,
		'Employee ID': undefined,
		'Public ESO ID': undefined,
		Title: undefined,
		'Business Unit': undefined,
		'Cost Center': undefined,
		Department: undefined,
		'Hospital Unit': undefined,
		Roles: undefined,
		'Supervisor Name': undefined,
		'Requestee Name': undefined,
		'Requestor Name': undefined,
		Phone: undefined,
	});

	useEffect(() => {
		setRequest(prevRequest => {
			const updatedRequest = { ...prevRequest };

			// Define the key mappings
			const keyMappings = {
				'Requestee Name': 'f_full',
				Address: 'addressLineOne', //this one not really used
				'ESO ID': 'eso_id',
				Email: 'email',
				UPN: 'UPN',
				'Employee ID': 'employee_id',
				'Public ESO ID': 'public_eso_id',
				Title: 'title',
				'Business Unit': 'businessUnit',
				'Cost Center': 'costCenter',
				Department: 'department',
				'Hospital Unit': 'hospitalUnit',
				Roles: 'roles',
				'Supervisor Name': 'supervisorName',
				Phone: 'phone',
				// Add more key mappings as needed
			};

			if (requestor) {
				delete keyMappings['Requestee Name'];
				keyMappings['Requestor Name'] = 'f_full';
			}

			for (const key in updatedRequest) {
				if (
					keyMappings &&
					requestInfo &&
					keyMappings.hasOwnProperty(key) &&
					requestInfo.hasOwnProperty(keyMappings[key])
				) {
					updatedRequest[key] = requestInfo[keyMappings[key]];
				}
			}

			return updatedRequest;
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [requestInfo]);

	const CopyButtonRequesteeName = () => {
		return (
			<Tooltip
				title='Name Copied Successfully!'
				open={openTooltip}
				onClose={() => setOpenTooltip(false)}
				onClick={() => {
					navigator.clipboard
						.writeText(requestInfo.f_full)
						.then(() => {
							// Show tooltip
							setOpenTooltip(true);
							// Hide tooltip after 2 seconds
							setTimeout(() => {
								setOpenTooltip(false);
							}, 2000);
						});
				}}
			>
				<IconButton aria-label='copy'>
					<ContentCopyIcon />
				</IconButton>
			</Tooltip>
		);
	};
	return (
		<Grid container spacing={3} alignItems='center'>
			<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
				{Object.entries(request).map(
					([key, value]) =>
						value &&
						(assignInfo && key === 'Requestee Name' ? null : (
							<React.Fragment {...{ key }}>
								<Body2>
									<b>{key}: </b>
									{key === 'Address' ? (
										<>
											{requestInfo.addressLineOne} <br />
											{requestInfo.addressLineTwo}
										</>
									) : (
										<>
											{value}{' '}
											{key === 'Requestee Name' && (
												<CopyButtonRequesteeName />
											)}
										</>
									)}
								</Body2>
							</React.Fragment>
						))
				)}
			</Grid>
		</Grid>
	);
};

export default RequestInformation;
